import type { ReactNode } from 'react'
import { useEffect, useState } from 'react'
import ReactDOM from 'react-dom'

type PoralProps = {
  children?: ReactNode
}
export default function Portal({ children }: PoralProps) {
  const [hasMounted, setHasMounted] = useState(false)

  useEffect(() => {
    setHasMounted(true)
  }, [])

  if (!hasMounted) {
    return null
  }

  const portalRoot = document.querySelector(`#portal`)

  if (!portalRoot) {
    throw new Error("The element #portal wasn't found")
  }

  return ReactDOM.createPortal(children, portalRoot)
}
